import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';

interface StepType {
  label: string;
  Component: React.ReactNode;
}

interface ButtonActions {
  label: string;
  function: (type: string) => void;
  disabled?: boolean;
}

interface LinearStepperProps {
  steps: StepType[];
  isButtonHide?: boolean;
  stepperButton?: ButtonActions[];
  finalStepButtons?: ButtonActions[];
  activeStep?: number; // Make activeStep a controlled prop
}

export default function LinearStepper({
  steps,
  // isButtonHide = false,
  stepperButton,
  finalStepButtons,
  activeStep
}: LinearStepperProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    if (stepperButton?.[1]) {
      stepperButton[1].function('Next');
    }
  };

  const handleBack = () => {
    if (stepperButton?.[0]) {
      stepperButton[0].function('Back');
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((data, index) => {
          const { label } = data;
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <br />
      <React.Fragment>
        {steps[activeStep].Component}
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Button
            color="inherit"
            variant='contained'
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            {stepperButton?.[0]?.label}
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          {activeStep === steps.length - 1 ? (
            finalStepButtons?.map((button, index) => (
              <Button
                key={index}
                variant="contained"
                onClick={() => button.function(button.label)}
                disabled={button.disabled}
                sx={{ ml: index > 0 ? 1 : 0 }}
              >
                {button.label}
              </Button>
            ))
          ) : (
            <Button variant="contained" onClick={handleNext}>
              {stepperButton?.[1]?.label}
            </Button>
          )}
        </Box>
      </React.Fragment>
    </Box>
  );
}
